/**
 * tourSteps/myWorkSteps.js
 * Comprehensive tour steps for the My Work personalized employee workspace.
 * Covers user-scoped tasks, AI work briefings, effort variance alerts,
 * weekly capacity gauges, status filtering, and multi-view task execution.
 */

export const myWorkSteps = [
    {
        title: 'Personalized "My Work" Hub',
        description: 'Your dedicated individual workspace. Automatically aggregates every task where you are the assignee across all active projects.',
        selector: '[data-tour="mywork-header"]',
        placement: 'bottomLeft',
    },
    {
        title: 'AI Work Intelligence Briefing',
        description: 'Personalized AI briefing summarizing your highest-priority items for the week, impending milestone deadlines, and urgent action items across all projects.',
        selector: '[data-tour="mywork-ai-briefing"]',
        placement: 'bottom',
    },
    {
        title: 'Due Today & Effort Variance Alerts',
        description: 'The AI briefing highlights tasks due today and flags effort variance alerts whenever actual hours logged exceed estimated hours, helping you spot overruns before they escalate.',
        selector: '[data-tour="mywork-ai-briefing"]',
        placement: 'bottom',
    },
    {
        title: 'Weekly Capacity & Effort Overview',
        description: 'Real-time bandwidth monitoring. Tracks actual hours logged against your estimated workload and standard 40-hour weekly capacity, showing remaining availability.',
        selector: '[data-tour="mywork-capacity-overview"]',
        placement: 'bottom',
    },
    {
        title: 'Interactive Status Quick Filters',
        description: 'Click any status counter (Backlog, In Progress, Under Review, On Hold, Completed) to immediately filter your task workspace to that specific execution stage.',
        selector: '[data-tour="mywork-capacity-overview"]',
        placement: 'bottom',
    },
    {
        title: 'My Tasks Execution Workspace',
        description: 'Granular multi-filter controls allowing you to isolate tasks by project, priority, due date, sprint cycle, or milestone phase, alongside keyword search.',
        selector: '[data-tour="mywork-tasks-workspace"]',
        placement: 'top',
    },
    {
        title: 'Multi-View Execution & New Task Creation',
        description: 'Switch between List Table, Kanban Board, Gantt Timeline, or Sprint Planning, and click "+ New Task" to log new items directly into your personal workflow.',
        selector: '[data-tour="mywork-tasks-workspace"]',
        placement: 'top',
    },
];
